export class PaymentRequestModel {
    public isChecked!: boolean;
    public id!: number;
    public uId!: number;
    public status!: number;
    public numberOfPack!: number;
    public statusDetail!: any;
    public userName!: string;
    public createdBy!: any;
    public createdDate!: string;
    public phone!: string;
    public address!: string;
    public note!: string;
};